.global {
  line-height: 1.6;
}
